import React from 'react';
import classnames from 'classnames';
import { node, string, number, oneOf } from 'prop-types';

export const ALIGN_TOP = Symbol('align-top');
export const ALIGN_MIDDLE = Symbol('align-middle');
export const ALIGN_BOTTOM = Symbol('align-bottom');

const alignMap = {
  [ALIGN_TOP]: 'top',
  [ALIGN_MIDDLE]: 'middle',
  [ALIGN_BOTTOM]: 'bottom',
};

const Cell = ({ children, className, span, order, align, ...props }) => (
  <div
    {...props}
    className={classnames([
      'mdc-layout-grid__cell',
      {
        [`mdc-layout-grid__cell--span-${span}`]: span,
        [`mdc-layout-grid__cell--order-${order}`]: order,
        [`mdc-layout-grid__cell--align-${alignMap[align] || align}`]: align,
      },
      className,
    ])}
  >{children}</div>
);

Cell.propTypes = {
  children: node.isRequired,
  span: number,
  order: number,
  align: oneOf([ALIGN_TOP, ALIGN_MIDDLE, ALIGN_BOTTOM]),
  className: string,
};

Cell.defaultProps = {
  className: undefined,
  span: undefined,
  order: undefined,
  align: undefined,
};

export default Cell;
